import { z } from 'zod'

import type { OnboardingFlow } from '@scalar-org/entities/auth'
import type { BillingPlan } from '@scalar-org/entities/team'

import type { RequestService } from '../request'

export function paymentApiFactory(requestService: RequestService) {
  /** Start a stripe payment session */
  async function startSession(
    billingPlan: BillingPlan.ProMonthly | BillingPlan.ProYearly,
    redirectUrl?: string,
    flow?: OnboardingFlow,
  ) {
    return await requestService.request({
      url: 'core/payment/start',
      method: 'post',
      data: {
        billingPlan,
        redirectUrl,
        flow,
      },
      schema: z.string(),
    })
  }

  /** Start a stripe payment method session */
  async function startBillingSession(data: { paymentMethod?: boolean }) {
    return await requestService.request({
      url: 'core/payment/billing/start',
      method: 'post',
      schema: z.string(),
      data,
    })
  }

  return {
    startSession,
    startBillingSession,
  }
}
